import React from "react";

import cogniLogo from "../../images/cogni_logo.png";
import ErrorImage from "../../images/error.png";
import PwdResetSuccess from "../../images/PwdResetSuccess.png";
import "./error.css";

export const ErrorPage = props => {
  return (
    <Wrapper>
      {!props.showPasswordResetSuccess ? (
        props.fromPasswordReset ? (
          <PasswordResetContent {...props} />
        ) : (
          <Content {...props} />
        )
      ) : (
        <PasswordResetSuccess {...props} />
      )}
    </Wrapper>
  );
};

function Wrapper(props) {
  return (
    <div className="expired_alert_bg_img_login">
      <div className="expired_alert_login_bg_height">
        <div className="expired_alert_login_bg_width">
          <div className="row">{props.children}</div>
        </div>
      </div>
    </div>
  );
}

function Content(props) {
  return (
    <React.Fragment>
      <div className="col-md-12 col-lg-12 expired_alert_login_bg_width_left">
        <img
          className="centerImage"
          src={cogniLogo}
          alt="Assistant"
          title="Assistant"
        />
        <h2>Access error</h2>
        <p>
          The verification link is expired or invalid. Please sign up again!{" "}
        </p>
        <div className="expired_alert_left_bottom_img">
          <img
            src={ErrorImage}
            align="middle"
            alt="Link_expired"
            title="Link_expired"
          />
          <button
            className="workspace_button btn btn-primary"
            onClick={() =>
              props.history.replace(
                process.env.REACT_APP_UI_BASE_URL +
                  process.env.REACT_APP_UI_SIGNUP
              )
            }
          >
            Signup Again
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}

function PasswordResetContent(props) {
  return (
    <React.Fragment>
      <div className="col-md-12 col-lg-12 expired_alert_login_bg_width_left">
        <img
          className="centerImage"
          src={cogniLogo}
          alt="Assistant"
          title="Assistant"
        />
        <h2>Access error</h2>
        <p>The verification link is expired or invalid.</p>
        <div className="expired_alert_left_bottom_img">
          <img
            src={ErrorImage}
            align="middle"
            alt="Link_expired"
            title="Link_expired"
          />
          <button
            className="workspace_button btn btn-primary"
            onClick={() =>
              props.history.replace(
                process.env.REACT_APP_UI_BASE_URL +
                  process.env.REACT_APP_UI_FORGOT_PASSWORD_URL
              )
            }
          >
            Request Again
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}

function PasswordResetSuccess(props) {
  return (
    <React.Fragment>
      <div className="col-md-12 col-lg-12 expired_alert_login_bg_width_left">
        <img
          className="centerImage"
          src={cogniLogo}
          alt="Assistant"
          title="Assistant"
        />
        <h2>Success</h2>
        <p>The password has been successfully changed.</p>
        <div className="expired_alert_left_bottom_img">
          <img
            src={PwdResetSuccess}
            align="middle"
            alt="Link_expired"
            title="Link_expired"
          />
          <button
            className="workspace_button btn btn-primary"
            onClick={() =>
              props.history.replace(process.env.REACT_APP_UI_BASE_URL)
            }
          >
            Go to signin
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
